import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_PATHS } from '../constants/app-routes';
import { canViewClients } from '../constants/roles';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

/** Clientes: Admin (tudo), Líder (equipe + si), Membro (si). Escopo na API. */
export const clientsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.getToken()) {
    return router.createUrlTree([APP_PATHS.login]);
  }

  const current = auth.user();
  if (canViewClients(current?.role)) {
    return true;
  }

  return auth.loadProfile().pipe(
    map((user) =>
      canViewClients(user?.role) ? true : router.createUrlTree([APP_PATHS.myRoute])
    )
  );
};
